// extracted by mini-css-extract-plugin
export var o_portfolio = "portfolio-module--o_portfolio--e63d1";
export var o_portfolio__card = "portfolio-module--o_portfolio__card--9934b";
export var o_portfolio__container = "portfolio-module--o_portfolio__container--3842d";
export var o_portfolio__desc = "portfolio-module--o_portfolio__desc--1d240";
export var o_portfolio__grid = "portfolio-module--o_portfolio__grid--0a0c3";
export var o_portfolio__h2 = "portfolio-module--o_portfolio__h2--a0711";
export var o_portfolio__h3 = "portfolio-module--o_portfolio__h3--3a905";
export var o_portfolio__info = "portfolio-module--o_portfolio__info--16099";
export var o_portfolio__switcher = "portfolio-module--o_portfolio__switcher--a4e8a";